import React from "react";
import Header from "../../Components/Common/Header";
import Footer from "../../Components/Common/Footer";
import { connect } from "react-redux";
import InnerHeader from "../../Components/Common/InnerHeader";
import ApplicationDownload from "../../Components/Home/ApplicationDownload";

function DownloadsPage({ isLogin }) {
  return (
    <div className="container">
      <ApplicationDownload page />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    Open: state.init.loginOpen,
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(DownloadsPage);
